<script>
	import { onMount } from 'svelte';
	import { injectGlobalStyles } from './shared.js';

	export let teamId = '';
	let host;

	onMount(() => {
		const root = host?.getRootNode();
		if (root instanceof ShadowRoot) {
			injectGlobalStyles(root);
		}
	});
</script>

<div class="widget-card" bind:this={host}>
	<h3>Referee info</h3>
	<p>teamId: {teamId || 'n/a'}</p>
</div>

<style>
	:host { display: block; }
	.widget-card { border: 1px solid #d7dce2; border-radius: 12px; padding: 16px; background: #fff; }
	h3 { margin: 0 0 6px; }
	p { margin: 0; color: #53657b; }
</style>
